import { Component, Input, OnInit } from '@angular/core';
import { ConfigurationService, InpageAliasService, OmniDashboard } from 'src/app/my-sedgwick';
import { BaseComponent } from 'src/app/shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { Aliases } from '../../../models/aliases';

@Component({
    selector: 'app-off-work-card',
    template: `
    <app-panel
      [border]="'Empty'"
      class="tw-cursor-pointer"
      (click)="
        FeatureLogging(
          'EmployeesOffWork',
          'Employees Off Work',
          'Summary View Card'
        )
      "
      [shadow]="true"
      class="tw-cursor-pointer "
      routerLink="/summary/off-work"
      [canExpand]="false"
      tabindex="-1"
    >
      <div
        class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-text-white tw-bg-[var(--sed-warm-white-color)] container"
      >
        <app-loading-panel
          [state]="omniDashboard ? 'Loaded' : 'Loading'"
          loadingStyle="DotWhite"
          [error]="error"
        >
          <ng-template #content>
            <div class="tw-flex tw-flex-col tw-items-center">
              <h2 class="tw-text-[26px] app-mt8 tw-font-light " role="heading">
                {{ (employeeAlias | aliasTransform:'titlecase') + ' ' + ('off work' | translation: translationRequest) }}
              </h2>
              <div
                class="tw-text-[140px] tw-font-bold tw-leading-none tw-text-[var(--sed-black-80-color)]"
              >
                {{ omniDashboard.employeesOffWork }}
              </div>
              <div class="tw-text-[13px] tw-leading-none tw-font-light"></div>
              <div class="app-mb5 app-pt4">
                <app-button
                  emphasis="High"
                  arialabel="View details of {{ employeeAlias }} off work"
                  [role]="'link'"
                  label="View Details"
                >
                </app-button>
              </div>
            </div>
          </ng-template>
        </app-loading-panel>
      </div>
    </app-panel>
  `,
    styles: [
        `
      .container {
        height: 425px;
      }
    `,
    ],
    standalone: false
})
export class OffWorkCardComponent extends BaseComponent implements OnInit {
  @Input()
  omniDashboard: OmniDashboard;
  
  @Input()
  translationRequest: TranslationRequest;

  @Input()
  error: any;

  employeeAlias: Aliases = { value: 'Employees', key: 'employeePlural', isOverride: false } as Aliases;

  constructor(
    private aliases: InpageAliasService,
    private claimConfigService: ConfigurationService
  ) {
    super();
  }

  async ngOnInit() {
    this.employeeAlias = await this.aliases.replaceAliases(
      'employeePlural',
      this.claimConfigService.GetConfig.configFeatures.aliases
    );
  }
}
